import { createEntityAdapter } from "@reduxjs/toolkit";
import type { Contact } from "@repo/app-types/entities/contact";
import type { RootState } from "../../app/store.js";

export const contactsAdapter = createEntityAdapter<Contact>();

export const selectAllContacts = contactsAdapter.getSelectors().selectAll;
export const selectContactsDictionary = contactsAdapter.getSelectors(
  (state: RootState) => state.contacts,
).selectEntities;
